export const XSOLLA_COUNTRY = 'RU'
export const XSOLLA_CURRENCY = 'RUB'
export const XSOLLA_REGION_NAME = '俄罗斯'
export const XSOLLA_DEFAULT_CURRENCY = 'USD'

export const createDefaultXsollaPayInfo = (): goodsSetting.XsollaPayInfo => ({
  enableThirdPay: false,
  prodPrice: '',
  prodPriceCurrency: XSOLLA_DEFAULT_CURRENCY,
  // 俄罗斯 VAT 调价默认开启
  vatEnabled: true,
  prodNativePrices: [
    {
      regionCode: XSOLLA_COUNTRY,
      regionName: XSOLLA_REGION_NAME,
      prodPriceCurrency: XSOLLA_CURRENCY,
      originProdPrice: '',
      prodPrice: '',
    },
  ],
})

const formatPrice = (value: string | number | null | undefined): string => {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) && numberValue > 0 ? numberValue.toFixed(2) : ''
}

export const normalizeXsollaPayInfo = (
  data?: Partial<goodsSetting.XsollaPayInfo> | goodsSetting.ThirdPartyPayInfo | null,
): goodsSetting.XsollaPayInfo => {
  const defaultValue = createDefaultXsollaPayInfo()
  if (!data) return defaultValue
  const savedRussiaPrice = (data.prodNativePrices || []).find((item: any) =>
    [item.regionCode, item.country].includes(XSOLLA_COUNTRY),
  ) as any
  const originProdPrice = formatPrice(
    savedRussiaPrice?.originProdPrice ||
      savedRussiaPrice?.originalPrice ||
      savedRussiaPrice?.prodPrice ||
      savedRussiaPrice?.price,
  )
  // 存量数据没有 vatEnabled 字段时按关闭回显，默认开启只作用于新建配置
  const vatEnabled = data.vatEnabled ?? false

  return {
    ...defaultValue,
    ...data,
    enableThirdPay: data.enableThirdPay ?? false,
    prodPrice: formatPrice(data.prodPrice),
    prodPriceCurrency: XSOLLA_DEFAULT_CURRENCY,
    vatEnabled,
    prodNativePrices: [
      {
        regionCode: XSOLLA_COUNTRY,
        regionName: XSOLLA_REGION_NAME,
        prodPriceCurrency: XSOLLA_CURRENCY,
        originProdPrice,
        prodPrice: formatPrice(
          savedRussiaPrice?.prodPrice ||
            savedRussiaPrice?.price ||
            savedRussiaPrice?.originProdPrice ||
            savedRussiaPrice?.originalPrice,
        ),
      },
    ],
  }
}

export const updateXsollaRussiaPrice = (
  config: goodsSetting.XsollaPayInfo,
  originProdPrice: string,
  prodPrice = originProdPrice,
): goodsSetting.XsollaPayInfo => ({
  ...config,
  prodNativePrices: [
    {
      regionCode: XSOLLA_COUNTRY,
      regionName: XSOLLA_REGION_NAME,
      prodPriceCurrency: XSOLLA_CURRENCY,
      originProdPrice: formatPrice(originProdPrice),
      prodPrice: formatPrice(prodPrice),
    },
  ],
})

export const updateXsollaVat = (
  config: goodsSetting.XsollaPayInfo,
  vatEnabled: boolean,
): goodsSetting.XsollaPayInfo => ({ ...config, vatEnabled })

export const findRussiaNativePrice = (
  prices: goodsSetting.goodsPriceItem[] = [],
): goodsSetting.goodsPriceItem | undefined =>
  prices.find((item) => ['RU', 'RUS'].includes(item.regionCode) || item.regionName === '俄罗斯')

export const isValidXsollaSku = (sku: string): boolean => /^[A-Za-z0-9._-]{1,255}$/.test(sku)

export const mergeXsollaChannelPrices = (
  channelPrices: goodsSetting.ChannelPrices | undefined,
  config: goodsSetting.XsollaPayInfo,
  availableTimes?: number,
): goodsSetting.ChannelPrices => {
  const xsollaPayInfo = normalizeXsollaPayInfo(config)
  if (availableTimes === undefined) {
    delete xsollaPayInfo.availableTimes
  } else {
    xsollaPayInfo.availableTimes = availableTimes
  }
  return {
    ...(channelPrices || {}),
    priceInfo: {
      ...(channelPrices?.priceInfo || {}),
      xsolla_pay: xsollaPayInfo,
    },
  }
}
